export function snakecase(s: string): string {
    let r = '';
    for (let i = 0; i < s.length; i++) {
        const cp = s.codePointAt(i);
        if (cp && cp >= 65 && cp <= 90 && i !== 0) {
            r += `_${s[i]}`;
        } else if (cp === 45 || cp === 32) {
            r += `_`;
        } else {
            r += s[i];
        }
    }
    return r.toLowerCase();
}
